import React from "react";
var MessageContext = React.createContext({
    displaySuccess: function () { },
    displayWarning: function () { },
    displayError: function (error) { }
});
export default MessageContext;
